// Iteration 1.12 test-control frame handlers. Always present in every
// build; the only way to invoke them is for a server-side GameOrchestrator
// to push a `kind:"test.*"` frame over the WebSocket. In normal play the
// dispatch is dormant.
//
// Test results flow back over the iteration-1.10 `kind:"log"` channel:
// `log.info('test.snapshot', {...})` and similar. The Gateway buffers
// these per-game and the Go test driver retrieves them via
// coord.GetGameLogs.

import { log } from './log.js'
import { buttonRect } from './render/arena_lobby.js'

let refs = null

// configureTestHandlers wires the handler module to the page-scoped state
// objects. Called once from main.js after GameState/ProjectileSet/
// KeyboardInput exist.
//
// Iteration 1.14: takes an optional `canvas` ref so the test.click_lobby_start
// handler can synthesize a click on the Start button.
export function configureTestHandlers({ state, projectiles, input, canvas }) {
  refs = { state, projectiles, input, canvas: canvas ?? null }
}

// handleTestCommand dispatches one inbound `kind:"test.*"` frame.
export function handleTestCommand(obj) {
  if (refs === null) return
  switch (obj.kind) {
    case 'test.fire':
      refs.input.synthesizeFire(Number(obj.count) || 1)
      break
    case 'test.input':
      refs.input.overrideOnce({
        flags: obj.flags | 0,
        fireDelta: obj.fireDelta | 0,
        activateDelta: obj.activateDelta | 0,
      })
      break
    case 'test.click_lobby_start': {
      // Iter 1.14: synthesize a Click at the lobby Start-button center so
      // the real click handler in main.js drives the request_game_mode flow.
      // No-op if the canvas wasn't passed to configureTestHandlers.
      if (refs.canvas === null) break
      const r = buttonRect(refs.canvas)
      const cx = r.x + r.w / 2
      const cy = r.y + r.h / 2
      const rect = refs.canvas.getBoundingClientRect()
      const ev = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        clientX: rect.left + cx,
        clientY: rect.top + cy,
      })
      refs.canvas.dispatchEvent(ev)
      break
    }
    case 'test.snapshot_request': {
      const tag = String(obj.tag ?? '')
      const self = refs.state.self
        ? { x: refs.state.self.worldX, y: refs.state.self.worldY }
        : null
      log.info('test.snapshot', {
        tag,
        ships: refs.state.ships.size,
        projectiles: refs.projectiles.size(),
        self,
      })
      break
    }
    default:
      // unknown verb under test.* — ignore for forward compat
      break
  }
}
